(function(){
    'use strict';

    angular.module('dataHandlingActionFacebookAudience', ['ngAnimate', 'journey.canvas.srv', 'ngModalDragabble'])
        .controller('actionFacebookAudienceCtrl', ['$scope', '$rootScope', '$timeout', 'canvasService', 'helpers', actionFacebookAudienceCtrl]);

    function actionFacebookAudienceCtrl($scope, $rootScope, $timeout, canvasService, helpers){
        $scope.displayFacebookAudienceOptions = false;
        $scope.descriptionEmpty = false;
        $scope.createListName = {};
        $scope.search = {};

        function resetNode () {
            $scope.search.list = '';
            $scope.displayFacebookAudienceOptions = false;
            $scope.showSelectListError = false;
        }

        $rootScope.$on('displayFacebookAudienceModal', function(evt, conn, showTip) {
            var entry = document.getElementById(conn.id).getBoundingClientRect();
            const currentLang = $rootScope.jbLang;

            if (currentLang.toLowerCase() === 'japanese') {
                document.getElementById('facebook_audience_helperlink').setAttribute('href', 'https://kb.benchmarkemail.com/jp/automation-pro-facebook-audience/');
            }

            $scope.displayFacebookAudienceOptions = true;
            $scope.connections = angular.copy(conn);
            $scope.audienceError = false;
            $scope.descriptionEmpty = false;
            $scope.isLoading = true;
            $scope.audiences = [];

            if(!$scope.connections.data.action) {
                $scope.connections.data.action = '1';
            }

            $scope.setInitialState();
        });

        $scope.setInitialState = function () {
            canvasService.getConnections()
                .then(({data}) => {
                    $scope.isFbConnect = data.ValidConnection;
                    if($scope.isFbConnect) {
                        $scope.connectedUser = data.UserName || 'Unknown';
                        canvasService.getAudiences().then(({data}) => {
                            $scope.audiences = data.Audiances.data;
                            // select init audience
                            if(!$scope.connections.data.audiances.length && $scope.audiences.length) {
                                $scope.connections.data.audiances.push($scope.audiences[0].id);
                                $scope.connections.audience = JSON.stringify($scope.audiences[0]);
                            }
                            $scope.isLoading = false;
                        })
                        .catch(() => {
                            $scope.isFbConnect = false;
                            $scope.isLoading = false;
                        })
                    } else {
                        $scope.isLoading = false;
                    }
                })
                .catch(() => {
                    $scope.isFbConnect = false;
                    $scope.isLoading = false;
                });
        };

        $scope.$watch('connections.audience', (newData, old) => {
            if(newData && newData !== old) {
                const data = JSON.parse(newData);
                $scope.connections.data.audiances[0] = data.id;
                $scope.audienceError = false;
            }
        });

        $scope.$watch('connections.data.action', (newData, old) => {
            if(newData && newData !== old) {
                if($scope.connections.data.action == '1') {
                    Intercom('trackEvent', 'FB-Biz-AddAud', {
                        description : 'Facebook audience Add selected from removed to add'
                    });
                } else {
                    Intercom('trackEvent', 'FB-Biz-RemoveAud', {
                        description : 'Facebook audience Remove selected from add to remove'
                    });
                }
            }
        });

        $rootScope.$on('hideFacebookAudienceModal', function() {
            $scope.audienceError = false;
            resetNode();
        });

        $scope.goBackList = () => {
            $scope.createList = false;
            $scope.displayFacebookAudienceOptions = true;
        };

        $scope.cancel = function() {
            Intercom('trackEvent', 'FB-Biz-Cancel-C', {
                description : 'Facebook audience Cancel button click'
            });

            resetNode();

            var node = _.find($rootScope.connections, function (conn) {
                return conn.id === $scope.connections.id;
            });

            if ((!node || !(node.data && node.audience)) && !$scope.connections.isDummy) {
                // Execute listener when user cancel the add the node of delay
                $rootScope.$broadcast('deleteFBAudienceNode' + $scope.connections.id);
            }
        };

        $scope.save = function() {
            if (!$scope.connections.audience) {
                $scope.audienceError = true;
            } else {
                if($scope.connections.data.action == '1') {
                    Intercom('trackEvent', 'FB-Biz-Aud-AddSave', {
                        description : 'Facebook audience Add plus save'
                    });
                } else {
                    Intercom('trackEvent', 'FB-Biz-Aud-RemSave', {
                        description : 'Facebook audience Remove plus save'
                    });
                }

                Intercom('trackEvent', 'FB-Biz-SaveAudience', {
                    description : 'Facebook audience Save'
                });

                $rootScope.$emit('saveActionFacebookAudienceData' + $scope.connections.id, $scope.connections);
            }
        };

        $scope.connect = function () {
            Intercom('trackEvent', 'FB-Biz-Connect-C', {
                description : 'Facebook audience Connect button click',
            });

            const redirectUrl = window.location.origin + '/#/canvas/' + $rootScope.currentAPId;
            canvasService.fbConnect(redirectUrl)
                .then(({data}) => {
                    $rootScope.$emit('saveActionFacebookAudienceData' + $scope.connections.id, $scope.connections);
                    if (data !== undefined && data !== null
                        && data.RedirectUrl !== undefined && data.RedirectUrl !== null) {
                        localStorage.setItem('offToFacebook_' + $scope.connections.id, '1');
                        $timeout(() => {
                            window.location.replace(data.RedirectUrl);
                        }, 500);
                    }
                });
        };

        $scope.goBack = function () {
            $scope.disconnectFailed = false;
            $scope.isFbConnect = true;
        };

        $scope.sendToProListing = function () {
            window.location.replace(window.origin);
        };

        $scope.disconnectFacebook = function () {
            $scope.isLoading = true;
            canvasService.fbDisconnect()
                .then(({data}) => {
                    if(data.Disconnected === false) {
                        $scope.disconnectFailed = true;
                        $scope.apTitles = data.ValidateInformation &&
                            data.ValidateInformation.Journeys &&
                            data.ValidateInformation.Journeys.JourneySummary.length &&
                            data.ValidateInformation.Journeys.JourneySummary.map((i) => i.JourneyTitle) || [];
                        $scope.isLoading = false;

                    } else {
                        $rootScope.$emit('errorMsg', $scope.translate('canvas.facebook.audience.disconnected'), 'disconnected');
                        $scope.setInitialState();
                    }
                })
                .catch((err) => {
                    $scope.isLoading = false;
                });
        };

        $scope.displayModal = function(evt) {
            var windowHeight = window.innerHeight * 0.50;
            //Bottom to top
            if (evt.clientY > windowHeight) {
                $(".poc-list").css("top","-270px");
            }else {
                $(".poc-list").css("top","");
            }
            $scope.modalWindow = true;
        };

        $scope.hideModal = function(clearList) {
            if(clearList) {
                $scope.selectedKey = $scope.translate('commons.selectList');
                $scope.connections.data.selectedList = [];
            }
            $scope.modalWindow = false;
            $scope.search.list = "";
            $scope.contactListData = $rootScope.contactListData;

        };
    };
})();



// WEBPACK FOOTER //
// ./app/controllers/modals/actionFacebookAudienceController.js